<mat-sidenav-container class="h-screen overflow-hidden" [hasBackdrop]="false" [autosize]="true">
  <mat-sidenav #snav [opened]="true" role="main" class="!rounded-r-2xl !border-none !shadow-none !z-0"
    disableClose="true" [mode]="'push'">
    <div class="p-3 pt-6">
      <button mat-icon-button color="primary" aria-label="icon button with a navigation menu"
        (click)="collapsed = !collapsed">
        <lib-app-icon matListItemIcon icon="hamburger_icon" [size]="'24x24'" />
      </button>
      <lib-sidebar-header [collapsed]="collapsed"/>
      @if (navItems.length > 0) {
        <mat-nav-list>
          @for (item of navItems; track item.route) {
            <lib-sidenav-link [collapsed]="collapsed" [navigationItem]="item" routerLinkActive="activeRoute.isActive" />
          }
        </mat-nav-list>
      }
    </div>
  </mat-sidenav>
  <mat-sidenav-content [ngStyle]="{'overflow': isDrawerOpened ? 'hidden' : 'auto'}" class="!mr-0 sidenavContent">
    <lib-header [headerContent]="headerTemplate" [getProfilePicturePath]="this.getProfilePicturePath"
      [showDebugTrace]="showDebugTrace" />
    <router-outlet (activate)="onActivate($event)" />
    <lib-footer [footerContent]="footerTemplate" />
  </mat-sidenav-content>
</mat-sidenav-container>
<cal-transport-order-drive-instructions-dialog />
<cal-hover-tooltip />